import SetupAssurances from './SetupAssurances';

export default SetupAssurances;